import { FC, useState } from "react";
import { Button, Drawer, message, Modal, Popconfirm, Table, Tag } from "antd";
import {
  OrderPaymentConst,
  OrderPaymentModel,
} from "states/order/order.models";
import { ColumnsType } from "antd/lib/table";
import momentTz from "moment-timezone";
import { shallowEqual, useSelector } from "react-redux";
import { formatMoney } from "shared/plugins/string-helper";
import {
  CoreResource,
  momentDateTimeFormat,
  t,
} from "shared/plugins/localization";
import { selectCurrentBranch } from "states/branch/branch.slice";
import { OrderPaymentStatusTag } from "./order-payment-status-tag";
import { OrderPaymentMethodTag } from "./order-payment-method-tag";
import { completeOrderPaymentAPI } from "states/order/order.api";
import { UpdateDataSuccessfully } from "shared/constants/define-localization";

interface IOrderPaymentInfoModalProps {
  payments: OrderPaymentModel[];
  onModal: boolean;
  closeModal: () => void;
  onSuccess: (orderId: string) => Promise<void>;
}
export const OrderPaymentInfoModal: FC<IOrderPaymentInfoModalProps> = (
  props
) => {
  const { payments, onModal, closeModal, onSuccess } = props;
  const currentBranch = useSelector(selectCurrentBranch, shallowEqual);
  const [loading, setLoading] = useState(false);

  const handleCompletePayment = async (orderPaymentId: string) => {
    try {
      setLoading(true);
      await completeOrderPaymentAPI(orderPaymentId);
      Modal.success({
        title: "Notification",
        content: "Cập nhật thành công",
        afterClose: async () => {
          closeModal();
          await onSuccess(payments[0].orderId);
        },
      });
      setLoading(false);
    } catch (err) {
      message.error(
        err?.response?.data?.error?.message ??
          t(CoreResource, "DefaultErrorMessage")
      );
      setLoading(false);
    }
  };

  const columns: ColumnsType<OrderPaymentModel> = [
    {
      title: "Ngày tạo",
      dataIndex: "creationTime",
      key: "creationTime",
      render: (creationTime: string, item) => (
        <>
          {momentTz
            .tz(item.creationTime, currentBranch.ianaTimeZone)
            .format(momentDateTimeFormat())}
        </>
      ),
    },
    {
      title: "Số tiền",
      dataIndex: "amount",
      key: "amount",
      render: (amount: string, item) => <>{formatMoney(item.amount)}</>,
    },
    {
      title: "Phương thức",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      render: (paymentMethod: string, item) => (
        <OrderPaymentMethodTag method={paymentMethod} />
      ),
    },
    {
      title: "IP address",
      dataIndex: "ip",
      key: "ip",
      render: (ip: string, item) => <>{item.ipAddress}</>,
    },
    {
      title: "Trạng thái",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (paymentStatus: string, item) => (
        <OrderPaymentStatusTag status={paymentStatus} />
      ),
    },
    {
      title: "Ghi chú",
      dataIndex: "paymentNote",
      key: "paymentNote",
      render: (paymentNote: string, item) => <>{item.paymentNote}</>,
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (_action, item) =>
        item.paymentStatus !== OrderPaymentConst.status.done ? (
          <Popconfirm
            title="Bạn chắc chắn muốn hoàn tất thanh toán?"
            onConfirm={() => {
              handleCompletePayment(item.id);
            }}
            okText="Có"
            cancelText="Không"
          >
            <Button
              disabled={loading}
              type="primary"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              Hoàn tất
            </Button>
          </Popconfirm>
        ) : null,
    },
  ];
  return (
    <Drawer
      title="Chi tiết thanh toán"
      onClose={() => {
        closeModal();
      }}
      visible={onModal}
      width={1024}
    >
      <Table
        columns={columns}
        dataSource={payments}
        size="small"
        pagination={false}
      ></Table>
    </Drawer>
  );
};
